import type { HoursBarSegmentKind } from './hoursBarSegments';

/**
 * Segment colours (v8/ADR 16): unallocated is a 3px hatch (ADR 0024 technique).
 * Shared by the task's hours bar and the contract's (`ContractHoursBar`,
 * 3 Nov), so a segment means the same thing in both.
 */
export const HOURS_SEGMENT_SX: Record<HoursBarSegmentKind, Record<string, string>> = {
  logged: { background: 'var(--color-blue-80)' },
  allocated: { background: 'var(--color-blue-40)' },
  unallocated: {
    background:
      'repeating-linear-gradient(45deg, var(--color-fog-20) 0 3px, var(--color-fog-10) 3px 6px)',
  },
  over: { background: 'var(--color-coral-80)' },
};

/** Legend chips are solid even for the hatched segment (v8 markup: #c9ccd8 ≈ fog-40). */
export const HOURS_LEGEND_CHIP: Record<HoursBarSegmentKind, string> = {
  logged: 'var(--color-blue-80)',
  allocated: 'var(--color-blue-40)',
  unallocated: 'var(--color-fog-40)',
  over: 'var(--color-coral-80)',
};
